type Props = {
  dealt: boolean;
  scored: boolean;
  moved: boolean;
  score: string | null;
  onDeal: () => void;
  onGap: () => void;
  onMove: () => void;
};

export function MatchHud({
  dealt,
  scored,
  moved,
  score,
  onDeal,
  onGap,
  onMove,
}: Props) {
  const beat = !dealt ? 1 : !scored ? 2 : moved ? 3 : 2;
  const next =
    beat === 1
      ? "Next: overwrite the sample with the rate and loan amount on your statement."
      : beat === 2
        ? "Next: read the two rates in the well. Copper is you. Harbour is them."
        : "Next: stay with a script, or switch if they will not match.";

  return (
    <div className="match" role="status" aria-live="polite">
      <p className="match-kicker">{score ? `Rate gap · ${score}` : "Rate gap"}</p>
      <ol className="match-beats">
        <li className={beat === 1 ? "is-now" : dealt ? "is-done" : undefined}>
          <button type="button" onClick={onDeal}>
            <span>1 Deal</span>
            Your loan
          </button>
        </li>
        <li className={beat === 2 ? "is-now" : scored ? "is-done" : undefined}>
          <button type="button" onClick={onGap} disabled={!dealt}>
            <span>2 Gap</span>
            Rate difference
          </button>
        </li>
        <li className={beat === 3 ? "is-now" : moved ? "is-done" : undefined}>
          <button type="button" onClick={onMove} disabled={!scored}>
            <span>3 Move</span>
            Stay or switch
          </button>
        </li>
      </ol>
      <p className="match-keys">
        <span>
          <kbd>1</kbd> Deal
        </span>
        <span>
          <kbd>2</kbd> Gap
        </span>
        <span>
          <kbd>3</kbd> Move
        </span>
      </p>
      <p className="match-next">{next}</p>
    </div>
  );
}
